import { SHOW_STOPPER_EXTRA_FRAMES, SHOW_STOPPER_MISSING_FRAMES } from "../constants";

export const isMoreThen12FPS = (fps: number) => {
    return (fps >= SHOW_STOPPER_EXTRA_FRAMES) || (fps <= -(SHOW_STOPPER_MISSING_FRAMES))
};